import { createPaginator } from "@smithy/core";
import { ListSegmentReferencesCommand, } from "../commands/ListSegmentReferencesCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListSegmentReferences = createPaginator(EvidentlyClient, ListSegmentReferencesCommand, "nextToken", "nextToken", "maxResults");
